import { freeToPaidUpsellPrompt } from './freeToPaidUpsellPrompt';

export const packages = {
  freeToPaidUpsellPrompt,
};
